import { NgModule, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { CompletionApiService } from '../../../services/api/completion-api.service';
import { GeminiApiService } from '../../../services/api/gemini-api.service';
import { OpenaiAPIService } from '../../../services/api/openai-api.service';
import { TestRegistryService } from '../../services/test-registry.service';
import { createAITestDefinitions } from './ai-test-definitions';

/**
 * Module for AI and chat-related tests
 */
@NgModule({})
export class AITestsModule implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private testRegistry: TestRegistryService,
    private openaiApiService: OpenaiAPIService,
    private geminiApiService: GeminiApiService,
    private completionApiService: CompletionApiService
  ) {
    this.registerCategory();
    this.registerTests();
  }

  /**
   * Register the AI tests category
   */
  private registerCategory(): void {
    this.testRegistry.registerCategory({
      id: 'ai-tests',
      title: 'AI & Chat Tests',
      description: 'Test AI completions, streaming, and chat functionality',
      icon: 'smart_toy',
      color: 'primary',
      order: 1
    });
  }

  /**
   * Register all AI test definitions
   */
  private registerTests(): void {
    const testDefinitions = createAITestDefinitions(
      this.openaiApiService,
      this.geminiApiService,
      this.completionApiService,
      this.destroy$
    );

    testDefinitions.forEach(test => {
      this.testRegistry.registerTest(test);
    });

    console.log(`Registered ${testDefinitions.length} AI tests`);
  }

  /**
   * Cleanup when module is destroyed
   */
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}